import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ReportServiceConfig = {
  name: "Report",
  annotations: []
} as ServiceConfig;